import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    fontFamily:
        '"Helvetica Neue", Helvetica, Arial, sans-serif',
    color: '#333',
    background: '#fafafa'
};

const cardStyle: React.CSSProperties = {
    maxWidth: 480,
    textAlign: 'center'
};

const headingStyle: React.CSSProperties = {
    margin: '0 0 12px',
    fontSize: 20,
    fontWeight: 500
};

const bodyStyle: React.CSSProperties = {
    margin: '0 0 24px',
    fontSize: 14,
    color: '#666',
    lineHeight: 1.5
};

const buttonStyle: React.CSSProperties = {
    padding: '8px 20px',
    fontSize: 14,
    background: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer'
};

class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        // eslint-disable-next-line no-console
        console.error('Unhandled render error:', error, info?.componentStack);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={containerStyle}>
                    <div style={cardStyle}>
                        <h1 style={headingStyle}>Something went wrong</h1>
                        <p style={bodyStyle}>
                            The page hit an unexpected error. Please refresh
                            and try again. If the issue keeps happening, let
                            the team know.
                        </p>
                        <button
                            type="button"
                            style={buttonStyle}
                            onClick={this.handleReload}
                        >
                            Refresh page
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
